// Asset key constants. Real PNG assets loaded in PreloadScene.
// Tile atlas: tiny16_basictiles (8x15 of 16x16 tiles), tiny16_things (12x8), hero/npc (3x4 RPG Maker walk).
export const TEX = {
  bgTown: 'bg_town',
  bgField: 'bg_field',
  bgDungeon: 'bg_dungeon',
  pWarrior: 'p_warrior',
  pWizard: 'p_wizard',
  pArcher: 'p_archer',
  monBullfighter: 'mon_bullfighter',
  monLich: 'mon_lich',
  monGoblin: 'mon_goblin',
  monSkeleton: 'mon_skeleton',
  monSpiderqueen: 'mon_spiderqueen',
  hitFx: 'fx_hit',
  // Combat / skill FX
  fxSlash: 'fx_slash',
  fxWhirlwind: 'fx_whirlwind',
  fxShield: 'fx_shield',
  fxFireball: 'fx_fireball',
  fxStorm: 'fx_storm',
  fxManaShield: 'fx_mana_shield',
  fxArrow: 'fx_arrow',
  fxArrowRain: 'fx_arrow_rain',
  fxHeal: 'fx_heal',
  fxSpark: 'fx_spark',
  fxBasicMelee: 'fx_basic_melee',
  potion: 'icon_potion',
  npcBase: 'npc_base',
  gateEast: 'gate_east',
  gateWest: 'gate_west',
  // Lorencia MAP_01
  lorenciaTile: 'lorencia_tile',
  lorenciaPath: 'lorencia_path',
  lorenciaWater: 'lorencia_water',
  gateNorth: 'gate_north',
  gateSouth: 'gate_south',
  propFountain: 'prop_fountain',
  propDummy: 'prop_dummy',
  propTree: 'prop_tree',
  propBarrel: 'prop_barrel',
  propBench: 'prop_bench',
  propSignShop: 'prop_sign_shop',
  propTorch: 'prop_torch',
  propAuctionBoard: 'prop_auction',
  // Real Tiny16 / Town RPG pack assets (loaded as spritesheets / images)
  tinyTiles: 'tiny_tiles',           // tiny16_basictiles 16x16 (8 cols x 15 rows)
  tinyThings: 'tiny_things',         // tiny16_things 16x16 (12 cols x 8 rows)
  tinyChars: 'tiny_chars',           // tiny16_characters 16x16 (12 x 8) - NPC pool
  tinyDungeon: 'tiny_dungeon',       // tiny16_dungeon (sample bg image, not a tile atlas)
  tinyOverworld: 'tiny_overworld',   // tiny16_overworld (sample bg)
  dungeonBigTiles: 'dungeon_big',    // dungeon_tiles.png (bigger stone atlas)
  ttdDungeon: 'ttd_dungeon',         // top_down_dungeon dungeon.png (decorative bg)
  ttdChar: 'ttd_char',               // top_down_character_v4.png
  townHero: 'town_hero',             // hero.png 3x4 walkcycle 16x16
  townNpc: 'town_npc',               // npc.png 3x4 walkcycle 16x16
  // Hero base body (paperdoll layered system - per character-image.md §3)
  // 3x4 grid: cols = step-left | idle | step-right; rows = DOWN | LEFT | RIGHT | UP
  bodyMale: 'body_male',             // /assets/characters/body_male.png 939x1672 (frame 313x418)
  bodyFemale: 'body_female',         // /assets/characters/body_female.png 939x1672 (frame 313x418)
  // v3 multi-animation base body sheets (per-anim separate PNGs)
  bodyMaleV3Idle: 'body_male_v3_idle',       // 2x2 128px
  bodyMaleV3Walk: 'body_male_v3_walk',       // 4x4 96px
  bodyMaleV3Attack: 'body_male_v3_attack',   // 2x2 128px
  bodyMaleV3Hurt: 'body_male_v3_hurt',       // 2x2 128px
  bodyMaleV3Death: 'body_male_v3_death',     // 2x3 128px
  bodyFemaleV3Idle: 'body_female_v3_idle',
  bodyFemaleV3Walk: 'body_female_v3_walk',
  bodyFemaleV3Attack: 'body_female_v3_attack',
  bodyFemaleV3Hurt: 'body_female_v3_hurt',
  bodyFemaleV3Death: 'body_female_v3_death',
  // Mockup maps (used as fallback bg when no atlas covers theme)
  mock01Lorencia: 'mock_lorencia',
  mock02Noria: 'mock_noria',
  mock03Devias: 'mock_devias',
  mock04Dungeon: 'mock_dungeon',
  mock05Atlans: 'mock_atlans',
  mock06Tarkan: 'mock_tarkan',
  // Desert (Tarkan) tile fragments
  desertSand: 'desert_sand',         // Tile_5.png 256x256 sand block
  desertEdge: 'desert_edge',         // Tile_1.png 256x256 sand edge
  desertCactus: 'desert_cactus',     // Object_5.png
  desertRock: 'desert_rock',         // Object_8.png
  // Lorencia layered props (generated via generate2dsprite, 256x256 RGBA)
  propOakTree: 'prop_oak_tree',
  propFountainGen: 'prop_fountain_gen',
  propFountainIdle: 'prop_fountain_idle',
  // Animated map-transition portal gate (4-frame 2x2 idle, generated via generate2dsprite)
  propPortalGate: 'prop_portal_gate',
  propPortalGateIdle: 'prop_portal_gate_idle',
  propMarketStall: 'prop_market_stall',
  propHorseCart: 'prop_horse_cart',
  propWoodenBench: 'prop_wooden_bench',
  propStreetLantern: 'prop_street_lantern',
  propQuestBoard: 'prop_quest_board',
  // Lorencia base map (generated, 2560x2560)
  lorenciaBase: 'lorencia_base',
  // Noria layered props (generated via generate2dsprite, 256x256 RGBA)
  propAncientOak: 'prop_ancient_oak',
  propGlowingMushroom: 'prop_glowing_mushroom',
  propElfLantern: 'prop_elf_lantern',
  propRuneStone: 'prop_rune_stone',
  // Noria base map (generated, 1920x1280)
  noriaBase: 'noria_base',
  // Devias layered props (generated via generate2dsprite, 256x256 RGBA)
  propSnowyPine: 'prop_snowy_pine',
  propIcePillar: 'prop_ice_pillar',
  propHunterTent: 'prop_hunter_tent',
  propSnowCampfire: 'prop_snow_campfire',
  propRuinedPillar: 'prop_ruined_pillar',
  propIceLantern: 'prop_ice_lantern',
  // Devias base map (generated, 1920x1280)
  deviasBase: 'devias_base',
  // Atlans layered props (generated via generate2dsprite, 256x256 RGBA)
  propFallenColumn: 'prop_fallen_column',
  propKelp: 'prop_kelp',
  propGiantClam: 'prop_giant_clam',
  propGlowJellyfish: 'prop_glow_jellyfish',
  propTritonStatue: 'prop_triton_statue',
  propSeaShrine: 'prop_sea_shrine',
  // Atlans base map (generated, 1920x1280)
  atlansBase: 'atlans_base',
  // Dungeon layered props (generated via generate2dsprite, 256x256 RGBA)
  propWallTorch: 'prop_wall_torch',
  propStoneCoffin: 'prop_stone_coffin',
  propIronCage: 'prop_iron_cage',
  propSkullPile: 'prop_skull_pile',
  propBloodAltar: 'prop_blood_altar',
  propDarkThrone: 'prop_dark_throne',
  // Dungeon base map (generated, 1920x1280)
  dungeonBase: 'dungeon_base',
  // Tarkan layered props (generated via generate2dsprite, 256x256 RGBA)
  propDesertPalm: 'prop_desert_palm',
  propCaravanTent: 'prop_caravan_tent',
  propCamelSkeleton: 'prop_camel_skeleton',
  propSphinxStatue: 'prop_sphinx_statue',
  propSandstoneObelisk: 'prop_sandstone_obelisk',
  propPharaohSarcophagus: 'prop_pharaoh_sarcophagus',
  // Tarkan base map (generated, 1920x1280)
  tarkanBase: 'tarkan_base',
  // Icarus layered props (generated via generate2dsprite, 256x256 RGBA)
  propMarbleColumn: 'prop_marble_column',
  propAngelStatue: 'prop_angel_statue',
  propSkyLantern: 'prop_sky_lantern',
  propCrystalAltar: 'prop_crystal_altar',
  propWindPad: 'prop_wind_pad',
  propPegasusShrine: 'prop_pegasus_shrine',
  // Icarus base map (generated, 1920x1280)
  icarusBase: 'icarus_base',
  // Kalima layered props (generated via generate2dsprite, 256x256 RGBA)
  propBloodAltarKalima: 'prop_blood_altar_kalima',
  propBonePillar: 'prop_bone_pillar',
  propHellBrazier: 'prop_hell_brazier',
  propKundunCoffin: 'prop_kundun_coffin',
  propKundunSymbol: 'prop_kundun_symbol',
  propHangingCorpse: 'prop_hanging_corpse',
  // Kalima base map (generated, 1920x1280)
  kalimaBase: 'kalima_base',
  // Blood Castle layered props (generated via generate2dsprite, 256x256 RGBA)
  propSealedDoor: 'prop_sealed_door',
  propHolyPedestal: 'prop_holy_pedestal',
  propGothicCandelabra: 'prop_gothic_candelabra',
  propBrokenAngel: 'prop_broken_angel',
  propBloodCoffin: 'prop_blood_coffin',
  propGothicBloodAltar: 'prop_gothic_blood_altar',
  // Blood Castle base map (generated, 1920x1280)
  bloodCastleBase: 'blood_castle_base',
  // Devil Square layered props (generated via generate2dsprite, 256x256 RGBA)
  propDsMagicPillar: 'prop_ds_magic_pillar',
  propDsDemonPortal: 'prop_ds_demon_portal',
  propDsDemonTorch: 'prop_ds_demon_torch',
  propDsBloodAltar: 'prop_ds_blood_altar',
  propDsCorpseCage: 'prop_ds_corpse_cage',
  propDsSpikePillar: 'prop_ds_spike_pillar',
  // Devil Square base map (generated, 1920x1280)
  devilSquareBase: 'devil_square_base',
  // Chaos Castle layered props (generated via generate2dsprite, 256x256 RGBA)
  propCcChaosStatue: 'prop_cc_chaos_statue',
  propCcStoneBarrier: 'prop_cc_stone_barrier',
  propCcChaosAltar: 'prop_cc_chaos_altar',
  propCcChaosTorch: 'prop_cc_chaos_torch',
  propCcBrazier: 'prop_cc_brazier',
  // Chaos Castle base map (generated, 1920x1280)
  chaosCastleBase: 'chaos_castle_base',
  // Illusion Temple layered props (generated via generate2dsprite, 256x256 RGBA)
  propItCupIllusion: 'prop_it_cup_illusion',
  propItBuffPillar: 'prop_it_buff_pillar',
  propItArcaneLantern: 'prop_it_arcane_lantern',
  propItVanaStatue: 'prop_it_vana_statue',
  propItTeleportPad: 'prop_it_teleport_pad',
  // Illusion Temple base map (generated, 1920x1280)
  illusionTempleBase: 'illusion_temple_base',
  // Crywolf layered props (generated via generate2dsprite, 256x256 RGBA)
  propCwWolfStatue: 'prop_cw_wolf_statue',
  propCwWarDrum: 'prop_cw_war_drum',
  propCwWarBanner: 'prop_cw_war_banner',
  propCwFortressTower: 'prop_cw_fortress_tower',
  propCwFortressBrazier: 'prop_cw_fortress_brazier',
  propCwWolfThrone: 'prop_cw_wolf_throne',
  // Crywolf base map (generated, 1920x1280)
  crywolfBase: 'crywolf_base',
  // Castle Siege layered props (generated via generate2dsprite, 256x256 RGBA)
  propCsCastleGate: 'prop_cs_castle_gate',
  propCsCastleTower: 'prop_cs_castle_tower',
  propCsWarCannon: 'prop_cs_war_cannon',
  propCsWarTorch: 'prop_cs_war_torch',
  propCsDefenderFlag: 'prop_cs_defender_flag',
  propCsLorenciaCrown: 'prop_cs_lorencia_crown',
  // Castle Siege base map (generated, 1920x1280)
  castleSiegeBase: 'castle_siege_base',
  // Golden Invasion layered props (generated via generate2dsprite, 256x256 RGBA)
  propGiTreasureChest: 'prop_gi_treasure_chest',
  propGiGoldenObelisk: 'prop_gi_golden_obelisk',
  propGiGoldenShrine: 'prop_gi_golden_shrine',
  propGiGoldenLion: 'prop_gi_golden_lion',
  propGiGoldenBrazier: 'prop_gi_golden_brazier',
  // Golden Invasion base map (generated, 1920x1280)
  goldenInvasionBase: 'golden_invasion_base',
  // Hero Dungeon layered props (generated via generate2dsprite, 256x256 RGBA)
  propHdCrystalPillar: 'prop_hd_crystal_pillar',
  propHdHeroPedestal: 'prop_hd_hero_pedestal',
  propHdDivineLantern: 'prop_hd_divine_lantern',
  propHdGuardianAltar: 'prop_hd_guardian_altar',
  propHdCrystalPool: 'prop_hd_crystal_pool',
  propHdAetheriaSymbol: 'prop_hd_aetheria_symbol',
  // Hero Dungeon base map (generated, 1920x1280)
  heroDungeonBase: 'hero_dungeon_base',
  // Swamp of Calmness layered props (generated via generate2dsprite, 256x256 RGBA)
  propScTwistedTree: 'prop_sc_twisted_tree',
  propScLilyPad: 'prop_sc_lily_pad',
  propScMushroomCluster: 'prop_sc_mushroom_cluster',
  propScPetrifiedWarrior: 'prop_sc_petrified_warrior',
  propScSnakeStatue: 'prop_sc_snake_statue',
  propScPoisonCauldron: 'prop_sc_poison_cauldron',
  propScSwampLantern: 'prop_sc_swamp_lantern',
  propScMossRock: 'prop_sc_moss_rock',
  // Swamp of Calmness base map (generated, 1920x1280)
  swampOfCalmnessBase: 'swamp_of_calmness_base',
  // Lorencia Outskirt layered props (generated via generate2dsprite, 256x256 RGBA)
  propOakSapling: 'prop_oak_sapling',
  propBerryBush: 'prop_berry_bush',
  propQuestSignpost: 'prop_quest_signpost',
  propMossyRocks: 'prop_mossy_rocks',
  propCattailReeds: 'prop_cattail_reeds',
  propStrawDummy: 'prop_straw_dummy',
  // Lorencia Outskirt base map (generated, 1920x1280)
  lorenciaOutskirtBase: 'lorencia_outskirt_base',
  // Pet companion sheets (generated 2x2 idle hover, 256x256 per frame)
  petFairy: 'pet_fairy',
  petDemon: 'pet_demon',
  petAngel: 'pet_angel',
  // ----- Layered paperdoll atlases (per character-image.md §7.7) -----
  atlasBase: 'atlas_base',
  atlasHair: 'atlas_hair',
  atlasArmor: 'atlas_armor',
  atlasWeapon: 'atlas_weapon',
  atlasShield: 'atlas_shield',
  atlasFx: 'atlas_fx',
  atlasMount: 'atlas_mount',
  atlasEye: 'atlas_eye',
  atlasIcons: 'atlas_icons',
  // Character select MU Online style portraits + hall background
  csBg: 'cs_bg',
  csWarrior: 'cs_warrior',
  csWizard: 'cs_wizard',
  csArcher: 'cs_archer',
  // Welcome / Login screen MU Online style hero key art
  loginBg: 'login_bg',
  loginLogo: 'login_logo',
  loginWarrior: 'login_warrior',
  loginWizard: 'login_wizard',
  loginPanel: 'login_panel',
} as const;

export type TexKey = (typeof TEX)[keyof typeof TEX];

// Color palette per class for procedural sprites
export const CLASS_COLORS: Record<'warrior' | 'wizard' | 'archer', number> = {
  warrior: 0xc0392b,
  wizard: 0x2980b9,
  archer: 0x27ae60,
};
